export enum DiscountType {
  FIXED_AMOUNT = "FIXED_AMOUNT",
  FIXED_PERCENT = "FIXED_PERCENT",
  VARIABLE = "VARIABLE",
  VARIABLE_AMOUNT = "VARIABLE_AMOUNT",
  VARIABLE_PERCENT = "VARIABLE_PERCENT",
}
